import React from "react";
import { TimeAndAttendanceFacadeProvider } from "./facades/TimeAndAttendance.facade";
import { TimeAndAttendanceServiceProvider } from "./services/TimeAndAttendance.service";
import { TimeAndAttendanceRoutes } from "./TimeAndAttendanceRoutes";

export const TimeAndAttendance = () => {
  return (
    <div>
      <TimeAndAttendanceServiceProvider>
        <TimeAndAttendanceFacadeProvider>
          <TimeAndAttendanceRoutes></TimeAndAttendanceRoutes>
        </TimeAndAttendanceFacadeProvider>
      </TimeAndAttendanceServiceProvider>
    </div>
  );
};
